let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kpHRm")).then(() => parcelRequire('3w3bV'));